import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import { SpotCard } from "@/components/SpotCard";
import { api } from "@/lib/api";
import type { Spot } from "@/lib/spots";
import { usePrefs } from "@/contexts/PrefsContext";

export const FeaturedSpots = () => {
  const { t } = usePrefs();
  const [rows, setRows] = useState<Spot[]>([]);
  useEffect(() => { api.get("/public-spots/featured").then((r) => setRows(r.data)).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <section id="featured-spots" data-testid="featured-spots" className="space-y-4 scroll-mt-24">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h2 className="font-display text-xl sm:text-2xl font-black inline-flex items-center gap-2"><Sparkles className="h-5 w-5 text-emerald-600" />{t("spot.featured")}</h2>
          <p className="text-sm text-muted-foreground">{t("spot.featuredSub")}</p>
        </div>
        <Link to="/app/spots" data-testid="featured-spots-all" className="shrink-0 text-sm font-bold text-primary inline-flex items-center gap-1">{t("spot.seeAll")}<ArrowLeft className="h-4 w-4 ltr:rotate-180" /></Link>
      </div>
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2 snap-x">
        {rows.map((s, i) => <div key={s.spot_id} className="w-64 sm:w-72 shrink-0 snap-start"><SpotCard s={s} index={i} /></div>)}
      </div>
    </section>
  );
};
